'use client';

import { useEffect } from 'react';
import { DEPLOY_CHUNK_RELOAD_GUARD, isDeployChunkFailure } from './chunkReload';

/** After a deploy, cached HTML may reference removed JS chunks — reload once. */
export function DeployChunkRecovery() {
  useEffect(() => {
    const reloadOnce = () => {
      if (sessionStorage.getItem(DEPLOY_CHUNK_RELOAD_GUARD)) return;
      sessionStorage.setItem(DEPLOY_CHUNK_RELOAD_GUARD, '1');
      window.location.reload();
    };

    const onError = (event: ErrorEvent) => {
      const target = event.target;
      const src = target instanceof HTMLScriptElement ? target.src : (event.filename ?? '');
      if (isDeployChunkFailure(event.message ?? '', src)) {
        reloadOnce();
      }
    };

    const onRejection = (event: PromiseRejectionEvent) => {
      const reason = event.reason as { message?: string; name?: string } | undefined;
      const message = reason?.message ?? String(reason ?? '');
      if (reason?.name === 'ChunkLoadError' || isDeployChunkFailure(message, '')) {
        reloadOnce();
      }
    };

    window.addEventListener('error', onError, true);
    window.addEventListener('unhandledrejection', onRejection);
    const clearGuard = window.setTimeout(() => sessionStorage.removeItem(DEPLOY_CHUNK_RELOAD_GUARD), 15_000);

    return () => {
      window.removeEventListener('error', onError, true);
      window.removeEventListener('unhandledrejection', onRejection);
      window.clearTimeout(clearGuard);
    };
  }, []);

  return null;
}
